export default import.meta.ROLLDOWN_FILE_URL_dUiJwbi_88qwDMGeS6xicg